<template>
    <span>
        <div class="vx-row ml-3 mt-8 mb-4">
            <div class="vx-col-w-full flex">
                <vs-checkbox color="primary" v-model="is_tab_expand" icon-pack="feather" icon="icon-check"
                    class="font-bold">Show tab titles</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
                    :key="isSmallerScreen">
                    <vs-tab v-if="$canAny(['view-raw-material-codes-setting'])" icon-pack="feather" icon="icon-sliders"
                        :label="is_expand ? 'RM Codes' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <raw-material-codes-settings />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-sliders" :label="is_expand ? 'RM Settings' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ManageRawMaterialSettings />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-file-text" :label="is_expand ? 'ECD Settings' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ECDSettings />
                        </div>
                    </vs-tab>

                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>
import RawMaterialCodesSettings from "@/views/pages/settings/General/RawMaterialCodesSettings";
import ManageRawMaterialSettings from '@/views/pages/settings/General/ManageRawMaterialSettings.vue'
import ECDSettings from '@/views/pages/settings/General/ECDSettings.vue'

export default {
    name: 'SupplierSettings',
    data() {
        return {
            is_expand: true
        }
    },
    components: {
        RawMaterialCodesSettings,
        ManageRawMaterialSettings,
        ECDSettings
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        is_tab_expand: {
            get() { return this.is_expand },
            set(val) { this.is_expand = val }
        },
    },
}
</script>
<style lang="">

</style>